import set from 'lodash.set';
import get from 'lodash.get';

/* eslint-disable */
export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function formatLocationName({
  // eslint-disable-next-line camelcase
  country, address, city, postal_code,
}) {
  let nameParts = [];

  // eslint-disable-next-line camelcase
  nameParts.push(...[address, postal_code, city]);
  if (country) {
    nameParts.push(country.name);
  }
  nameParts = nameParts.filter((part) => !!part);
  return nameParts.join(', ');
}

export function range(end, start = 0, step = 1) {
  const arr = [];
  for (let i = start; i < end; i += step) {
    arr.push(i);
  }
  return arr;
}

export function dotNotationToNested(obj) {
  const nested = {};
  Object.keys(obj)
    .forEach(key => set(nested, key, obj[key]));
  return nested;
}

export function getUsingDotNotation(obj, path) {
  return get(obj, path);
}
